$(document).ready(function () {
  const target = document.querySelector(".ess-vt-numbers-section");
  const gifOne = document.querySelector(".ess-vt-numbers-section__animation-1");
  const gifTwo = document.querySelector(".ess-vt-numbers-section__animation-2");
  const sectionOne = document.querySelector(".section--1");
  const sectionTwo = document.querySelector(".section--2");
  const sectionThree = document.querySelector(".section--3");
  const sectionFour = document.querySelector(".section--4");
  const sectionFive = document.querySelector(".section--5");

  const options = {
    rootMargin: "0px 0px -80% 0px",
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(target);

        // fade in section 1
        sectionOne.classList.add("show");

        // fade in section 2
        setTimeout(() => {
          sectionTwo.classList.add("show");
        }, 1800);

        // play section 2 animation, 2
        setTimeout(() => {
          gifOne.classList.add("show");
        }, 2100);

        // fade in section 3 and 4
        setTimeout(() => {
          sectionThree.classList.add("show");
          sectionFour.classList.add("show");
        }, 5600);

        // fade in section 5
        setTimeout(() => {
          sectionFive.classList.add("show");
        }, 7100);

        // play animation 2
        setTimeout(() => {
          gifTwo.src = "/pages/vermont/assets/img/ASHTO_VT_gif8.gif";
        }, 7400);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  observer.observe(target);
});
